import { Component, OnInit, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { UserService } from '../../../../services/user-service/user.service';
import { QuickDialog } from '../../QuickDialog';
import { CompanyLocation } from '../../../../DataStructures/CompanyLocation/CompanyLocation';

@Component({
  selector: 'app-select-users-dialog',
  templateUrl: './select-users-dialog.component.html',
  styleUrls: ['./select-users-dialog.component.css']
})
export class SelectUsersDialogComponent implements OnInit {

  dataSet:Array<SearchComponentDataSet>;
  filterList:Array<any>;
  options:any;

  constructor(private userService:UserService,private dialog: MatDialog,public dialogRef: MatDialogRef<SelectUsersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) options:SelectUsersOptions) {

      this.options = options;
    }

  ngOnInit() {
    this.dataSet = this.options.dataSet;
    this.filterList = this.dataSet;
  }

  filterData(substring : string){
    substring = substring.trim().toLowerCase();

    if(substring.trim() == ""){
      this.filterList = this.dataSet;
    }else{
      this.filterList = this.dataSet.filter(x => x.firstname.toLowerCase().includes(substring) || x.lastname.toLowerCase().includes(substring) || x.fullname.toLowerCase().includes(substring) || x.id.toLowerCase().includes(substring));
    }
  }

  done(){
    this.dialogRef.close();
  }
}

export interface SelectUsersOptions{
  dataSet:Array<SearchComponentDataSet>
  searchPlaceHolder?:string
  closeText?:string
}
export class SearchComponentDataSet{
  id:string;
  firstname:string;
  lastname:string;
  fullname:string;
  address:string;

  getTitle(){
    return this.firstname + " " + this.lastname;
  }
}
